<template>
    <div class="fuel-logos" :style="{ bottom: bottomElOffset }">
        <div class="fuel-logos__inner">
            <a v-if="selectedPOIs.includes('gasStations')" href="http://www.bmaw.gv.at/" target="_blank" class="fuel-logos__link">
                <img :src="`${publicPath}/images/logos/bmdw.jpg`" class="fuel-logos__image" alt="BMDW Logo">
            </a>
            <a href="https://www.e-control.at/" target="_blank" class="fuel-logos__link">
                <img :src="`${publicPath}/images/logos/econtrol.svg`" class="fuel-logos__image fuel-logos__image--smaller" alt="E-Control Logo">
            </a>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    data() {
        return {
            publicPath: process.env.BASE_URL,
            bottomElOffset: 0
        }
    },
    computed: {
        ...mapGetters(['mobile', 'mobileSidebarHeightMode', 'mobileSidebarHeight', 'selectedPOIs'])
    },
    watch: {
        mobileSidebarHeightMode(val, oldVal) {
            if(this.mobile && val !== 'full' && oldVal !== 'full') {
                this.updateBottomPlacement();
            }
        },
    },
    mounted() {
        this.updateBottomPlacement()
    },
    methods: {
        updateBottomPlacement() {
            if(!this.mobile) return false;
            const correctionMultiplier = this.mobileSidebarHeightMode === 'middle' ? 0.5 : 1;
            this.bottomElOffset = `calc(${this.mobileSidebarHeight} - ${49 * correctionMultiplier}px`;
        },
    },
}
</script>

<style lang="scss">
.fuel-logos {
    position: absolute;
    left: 30px;
    z-index: $marker-highest-z + 5;
    background: white;
    border-radius: 6px;

    @include mq($until: tablet) {
        left: 8px;
        bottom: 8px;
        margin-bottom: 8px;
        transition: opacity 0.2s;

        .is-sidebar-moving-transition &,
        .is-sidebar-moving-touch & {
            transition-delay: 0s;
            opacity: 0;
        }
    }

    @include mq(tablet) {
        bottom: 30px !important;
    }

    &__inner {
        padding: 4px;
        display: flex;
        align-items: center;
        min-height: 27px;
    }

    &__link {
        display: inline-block;
        line-height: 0;
        
        &:not(:last-child) {
            margin-right: 4px;
        }
    }

    &__image {
        height: 25px;

        &--smaller {
            height: 18px;
        }
    }
}
</style>